import { SvgIcon, SvgIconProps } from '@mui/material';

export const Cancel = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      d="M2.75 12A9.25 9.25 0 0 1 12 2.75c2.284 0 4.375.828 5.989 2.2L4.95 17.989c-1.372-1.614-2.2-3.705-2.2-5.989zm3.261 7.05c1.614 1.372 3.705 2.2 5.989 2.2A9.25 9.25 0 0 0 21.25 12c0-2.284-.828-4.375-2.2-5.989L6.011 19.05zM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25z"
      fill="currentColor"
    />
  </SvgIcon>
);
